import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OverlayModule, CdkOverlayOrigin } from '@angular/cdk/overlay';

import { StatusBadge } from "../../ui/status-badge/status-badge";
import { FilterOptions } from '../../utils/types';
import { Filter } from "../filter/filter";
import { Search } from "../search/search";

@Component({
  selector: 'app-data-table',
  imports: [CommonModule, StatusBadge, Filter, TranslatePipe, OverlayModule, Search],
  templateUrl: './data-table.html',
  styleUrl: './data-table.css'
})
export class DataTable {
  @Input() columns: any[] = [];
  @Input() data: any[] = [];
  @Input() loading = false;
  @Input() filterOptions!: FilterOptions;
  @Input() defaultFilter!: FilterOptions;

  @Input() showSearch = true;
  @Input() showFilter = true;
  @Input() showCreate = false;
  @Input() showPagination = true;

  @Input() totalRecords = 0;
  @Input() page = 1;
  @Input() pageSize = 10;
  @Input() gridTemplateColumns? = 'repeat(12, minmax(0, 1fr))';
  @Output() pageChange = new EventEmitter<number>();
  @Output() applyFilters = new EventEmitter<FilterOptions>();
  @Output() resetFilters = new EventEmitter<void>();
  @Output() createClick = new EventEmitter();

  overlayOrigin!: CdkOverlayOrigin;
  isDropdownOpen = false;
  dropdownActions: any[] = [];

  Math = Math;
  Number = Number;

  ngOnInit() {
  }

  changePage(newPage: number) {
    this.pageChange.emit(newPage);
  }

  onApplyFilters(filters: FilterOptions) {
    this.applyFilters.emit(filters);
  }

  onResetFilters() {
    this.resetFilters.emit();
  }

  onCreateClick() {
    this.createClick.emit();
  }

  openDropdown(actions: any[], origin: CdkOverlayOrigin) {
    this.dropdownActions = actions;
    this.overlayOrigin = origin;
    this.isDropdownOpen = true;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  onActionClick(item: any) {
    item?.action?.();
    this.closeDropdown();
  }

  hasValidActions(actions: any[]): boolean {
    return Array.isArray(actions) && actions.some(a => a?.label);
  }

  onSearchChange(value: string) {
    const search = value.toLowerCase().trim();
    
    //implement searching here
  }


}
